import { useState } from "react"

export const usePurchaseStockForm = () => {
    const [openProduct, setOpenProduct] = useState(false);

    return {
        openProduct, setOpenProduct,
    }
}